import { Component, OnInit } from '@angular/core';
import { Rebate } from '../../../../classes/Rebate';
import { GlobalService } from '../../../services/global.service';
import { LoginService } from '../../../services/login.service';
import { ModelService } from '../../../services/model.service';

@Component({
  selector: 'app-rebates',
  templateUrl: './rebates.component.html',
  styleUrls: ['./rebates.component.scss']
})
export class RebatesComponent implements OnInit {

  rebatesData: Rebate[] = [];
  contentVisible: boolean = false;

  availableRoles: string[] = [ 'admin', 'installer' ];
  isAvailable: boolean = true;

  constructor ( 
    private model: ModelService,
    private global: GlobalService,
    private loginService: LoginService ) {
    this.global.setDocumentTitle( 'Rebates/Incentives' );
    if ( this.availableRoles.indexOf( this.loginService.userInfo.role ) === -1 ) this.isAvailable = false;
    else this.isAvailable = true;
  }

  ngOnInit ( ) {
    this.model.getRebatesData( ( rbData ) => {
        this.contentVisible = true;
        this.rebatesData = rbData;
    }, { 'showAll': true });
  }

}



// WEBPACK FOOTER //
// /root/anvel/angular/app/components/rebates/rebates/rebates.component.ts